let CDL_WORKER_PROTOCOL = {
    LOAD_FILE: 1,
    GET_METADATA: 2,
    GET_POSITION_DATA: 3,
    GET_VARIABLE_STACK: 4,
    GET_THREADS: 5,
    STEP_INTO: 6,
    STEP_OUT: 7,
    STEP_OVER_FORWARD: 8,
    STEP_OVER_BACKWARD: 9,
    GO_TO_START: 10,
    GO_TO_END: 11,
    TOGGLE_BREAKPOINT: 12,
    BREAKPOINTS: 13,
    PLAY_FORWARD: 14,
    PLAY_BACKWARD: 15,
    REPLAY: 16,
    TOGGLE_BREAKPOINT_ENABLED: 17,
    GET_EXECUTION_TREE: 18,
    GO_TO_POSITION: 19,
    CLEAR_BREAKPOINTS: 20,
};
CDL_WORKER_PROTOCOL = Object.freeze(CDL_WORKER_PROTOCOL);

export default CDL_WORKER_PROTOCOL;
